import { render } from "./CropSizeWeeklyTable.vue?vue&type=template&id=725c1f4a"
import script from "./CropSizeWeeklyTable.vue?vue&type=script&lang=js"
export * from "./CropSizeWeeklyTable.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/models/liquidation.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fagro_exporter%2Fliquidations%2Fquery_by_provider%2Fcharts%2FCropSizeWeeklyTable.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__